module.exports = __webpack_public_path__ + "img/icon-nav8.0bf73d9c.svg";